import { observer } from 'mobx-react-lite';
import { Flex, Box, Text } from '@cad-arc';
import { PillUnit } from '@mark43/cad-api';
import { UnitPill } from './unit-pill';
import { Tooltip } from './tooltip';

export const MoreUnits = observer(function MoreUnits({
    units,
    ghostUnitIds,
}: {
    units: PillUnit[];
    ghostUnitIds?: number[];
}): React.ReactElement {
    return (
        <Tooltip
            placement="right"
            overlay={units.map((unit) => {
                return (
                    <Flex m="1" key={unit.id}>
                        <UnitPill
                            unit={unit}
                            variant={ghostUnitIds?.includes(unit.id) ? 'ghost' : 'default'}
                        />
                        <Box as="span" p="1">
                            {unit.tip}
                        </Box>
                    </Flex>
                );
            })}
        >
            <Box className="unit-pill-more-units" cursor="default">
                <Text fontWeight="bold" lineHeight="none">
                    +{units.length}
                </Text>
            </Box>
        </Tooltip>
    );
});
